const roundUpHours = (momentObj) => {
  return momentObj.minute() || momentObj.second() || momentObj.millisecond()
    ? momentObj.add(1, 'hour').startOf('hour')
    : momentObj.startOf('hour');
};

export { roundUpHours };
